exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-form {\n  display: flex;\n  flex-wrap: wrap;\n}\n.box {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  margin-right: 10px;\n}\n.delete-selected-mu {\n  position: absolute;\n  right: 8px;\n  top: 6px;\n  color: \"#5C6B77\";\n  cursor: pointer;\n  z-index: 99;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b082282","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"javascriptEnabled":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Searching/index.vue
// module id = dcX6
// module chunks = 142